// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1n8za","legacyBtn":"MutateMid_legacyBtn__32V9R"};